// TypeScript mirror of src/ui/tokens.css. The CSS file is the runtime source; this mirror exists
// so tests can pin that the two never drift (tests/ui/tokens.test.ts) and so the rare inline need
// (canvas, SVG) reads a token instead of retyping a hex. Colours = the vivid palette the Owner chose
// on 2026-10-18 (restyle direction C); do not "improve" them here either.

export const COLOR = Object.freeze({
  bg: '#eef2fb',
  bgLow: '#e3e9ff',
  bgContainer: '#e7ebf7',
  bgHigh: '#d4dcff',
  bgHighest: '#c5d0ff',
  surface: '#ffffff',
  ink: '#141a2e',
  inkSoft: '#4a5370',
  outline: '#7a84a3',
  border: '#c3cbe6',
  borderCard: '#e2e7f6',
  primary: '#2f55e6',
  primaryContainer: '#2040c2',
  onPrimary: '#ffffff',
  primarySoft: '#e3e9ff',
  onPrimarySoft: '#1c3bb0',
  brandTeal: '#12b5a5',
  brandLight: '#3f7bff',
  brandTealSoft: '#d9f5f1',
  error: '#c42b28',
  errorSoft: '#fef0f0',
  onErrorSoft: '#a4221e',
  secondary: '#4a5370',
  secondarySoft: '#e7ebf7',
  warning: '#b25f11',
  warningSoft: '#fff9eb',
  inverseSurface: '#1e2440',
  onInverse: '#eef2fb',
  success: '#278640',
  successSoft: '#eff9f1',
  onSuccessSoft: '#206c34',
  defect: '#d48217',
  defectSoft: '#fff9eb',
  onDefectSoft: '#b25f11',
  unable: '#d86215',
  unableSoft: '#fff5ec',
  onUnableSoft: '#b4480f',
  na: '#474d57',
  naStrong: '#646972',
  naSoft: '#f5f6f7',
  pending: '#7a84a3',
  pendingSoft: '#e7ebf7',
  ai: '#8a3ffc',
  aiBg: '#f1e9ff',
  aiBorder: '#d9c6ff'
});

export const RADIUS = Object.freeze({
  card: 20,
  sheet: 24,
  button: 16,
  control: 14,
  tile: 18,
  photo: 16,
  segmented: 16,
  segment: 12,
  pill: 999
});

export const SIZE = Object.freeze({
  topbar: 56,
  topbarTablet: 72,
  tabbar: 76,
  cta: 52,
  button: 44,
  buttonTablet: 48,
  segment: 40,
  segmentHit: 48,
  tile: 80,
  row: 64,
  rowLayout: 72,
  iconTile: 44,
  icon: 24,
  progress: 8,
  progressTablet: 6,
  pill: 26,
  chip: 44,
  input: 48,
  textarea: 96,
  hit: 48
});

export const SPACE = Object.freeze({
  unit: 4,
  gutter: 16,
  gutterWorkspace: 32,
  cardPad: 16,
  sectionGap: 24,
  rowGap: 8,
  controlGap: 12,
  photoGap: 12
});

// iPad: maximum two persistent panes; left 30% clamped to 288–420px (§23).
export const PANE = Object.freeze({ leftPercent: 30, leftMin: 288, leftMax: 420, maxPersistentPanes: 2 });

export const ICON_WEIGHT = 400;
export const TOAST_DURATION_MS = 2500;
export const MOTION = Object.freeze({ fastMs: 120, baseMs: 180 });
